<template>
  <div>
    <div class="notify-left">
      <img src="https://assets.sororitywars.app/icons/notify/V2/house.png" width="40" height="40" class="desktop-notify-image" />
    </div>
    <div class="notify-right">
      <button type="button" class="notify-close" aria-label="Dismiss notification" @click="$emit('closeMe')">&times;</button>
      <div class="notify-alert">Live alert</div>
      <div class="notify-title" v-if="notif.entry.content.myAction && (notif.entry.content.type === 'HOUSE.' || notif.entry.content.type === 'HOUSE.PENDING')">
        You sent an invite to
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.user.hashid } }">
          {{notif.entry.content.user.name}}
        </router-link>!
      </div>
      <div class="notify-title" v-if="!notif.entry.content.myAction && (notif.entry.content.type === 'HOUSE.' || notif.entry.content.type === 'HOUSE.PENDING')">
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.user.hashid } }">
          {{notif.entry.content.user.name}}
        </router-link> sent you an invite!
      </div>
      <div class="notify-title" v-if="notif.entry.content.type === 'HOUSE.ACCEPTED'">
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.user.hashid } }">
          {{notif.entry.content.user.name}}
        </router-link> is now your sister!
      </div>
      <div class="notify-title" v-if="notif.entry.content.type === 'HOUSE.REJECTED'">
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.user.hashid } }">
          {{notif.entry.content.user.name}}
        </router-link> rejected your invite!
      </div>
      <div class="notify-title" v-if="notif.entry.content.type === 'HOUSE.REMOVED'">
        You are no longer sisters with
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.user.hashid } }">
          {{notif.entry.content.user.name}}
        </router-link>
      </div>
    </div>
    <router-link class="notify-image pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.user.hashid } }">
      <img src="//assets.sororitywars.app/icons/notify/V2/house.png" width="40" height="40" class="notify-image" @click="$emit('closeMe')" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Invites',
  props: {
    notif: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
